"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var calcNumberDisplayed = function calcNumberDisplayed() {
  var buttonWidths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var containerWidth = arguments.length > 1 ? arguments[1] : undefined;
  var rightPadding = 16;
  var showMoreButtonWidth = 96;
  var widthAcc = 0;
  var totalDisplayedWidth = 0;
  var i = 0;
  buttonWidths.forEach(function (buttonWidth) {
    var widthWithPadding = buttonWidth + rightPadding;
    widthAcc += widthWithPadding;
    if (widthAcc <= containerWidth) {
      i++;
      totalDisplayedWidth = widthAcc;
    }
  });
  if (i < buttonWidths.length) {
    var spaceForShowMoreButton = containerWidth - totalDisplayedWidth;
    if (spaceForShowMoreButton < showMoreButtonWidth) {
      i--;
    }
  }
  return i;
};
var _default = exports.default = calcNumberDisplayed;